import Geocode from "react-geocode";

export const getLonAndLat = (address) => {
  Geocode.setApiKey("AIzaSyB97jNPcwMUTJCXHU0OHhsqNAUc9125qGA");
  const answer = Geocode.fromAddress(address).then(
    (response) => {
      const { lat, lng } = response.results[0].geometry.location;
      return {
        latitude: lat,
        longitude: lng
      }
    },
    (error) => {
      console.error(error);
    }
  );

  return answer

}